import './utils/i18n';
import Alpine from 'alpinejs';
import Ajax from '@imacrayon/alpine-ajax';
import AlpineI18n from 'alpinejs-i18n';
import AsyncAlpine from 'async-alpine';
import Collapse from './components/Collapse';
import Tab from './components/Tab';
import Header from './components/Header';
import Media from './components/Media';
import Image from './components/Image';
import Glossary from './components/Glossary';
import PageHero from './components/PageHero';
import ContactHero from './components/ContactHero';
import PtLatest from './components/PtLatest';
import Audio from './components/Audio';
import Timeline from './components/Timeline';
import FormJs from './components/FormJs';
import LanguageSuggestion from './components/LanguageSuggestion';
import LanguageSuggestionLoader from './components/LanguageSuggestionLoader';
import AjaxSpinner from './components/AjaxSpinner';
import SolrSearch from './components/SolrSearch';
import SendToDataLayer from './components/SendToDataLayer';
import PageFilter from './components/PageFilter';
import AOS from './plugins/aos';
import ConsentNavLock from './plugins/consent-nav-lock';
// Disabled together with the a11y-consent YouTube gate in Media.html (see setup.typoscript for the
// Cookiebot removal context). Uncomment when the a:placeholder markup comes back.
// import ConsentVideo from './plugins/consent-video';
import DetectLoading from './plugins/detect-loading';
import LazyLoad from './plugins/lazyload';
import ScrollOffset from './plugins/scroll-offset';
import VideoPlayer from './plugins/video-player';


// Alpine.js and any related setup needs to be included in the <head> area of the page. The final app.min.js will be
// bundled with Alpine (and other basic Alpine extensions) and put into <head> as a <script defer>-tag.
window.Alpine = Alpine;
AsyncAlpine.init(Alpine);
AsyncAlpine.start();

// Register components, plugins etc. before Alpine.start();
Alpine.data('Collapse', Collapse);
Alpine.data('Tab', Tab);
Alpine.data('Header', Header);
Alpine.data('Media', Media);
Alpine.data('Image', Image);
Alpine.data('Glossary', Glossary);
Alpine.data('PageHero', PageHero);
Alpine.data('ContactHero', ContactHero);
Alpine.data('PtLatest', PtLatest);
Alpine.data('Audio', Audio);
Alpine.data('Timeline', Timeline);
Alpine.data('FormJs', FormJs);
Alpine.data('LanguageSuggestion', LanguageSuggestion);
Alpine.data('LanguageSuggestionLoader', LanguageSuggestionLoader);
Alpine.data('AjaxSpinner', AjaxSpinner);
Alpine.data('SolrSearch', SolrSearch);
Alpine.data('SendToDataLayer', SendToDataLayer);
Alpine.data('PageFilter', PageFilter);
Alpine.plugin(Ajax);
Alpine.plugin(AlpineI18n);
Alpine.plugin(AOS);
Alpine.plugin(DetectLoading);
Alpine.plugin(LazyLoad);
Alpine.plugin(ScrollOffset);
Alpine.plugin(VideoPlayer);
Alpine.start();

// Run other things besides Alpine.js after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  ConsentNavLock();
  // ConsentVideo();
});
